<template>
  <div class="app-container">
    <div class="myradio">
      <el-button
        type="primary"
        plain
        size="small"
        icon="el-icon-back"
        @click="toTaskList()"
        style="margin-left: 10px; height: 32px; margin-right: 15px"
        >返回</el-button
      >
      <el-radio-group @change="handleClick" v-model="radio">
        <el-radio label>我审核</el-radio>
        <el-radio label="2">待我审核</el-radio>
        <el-radio label="1">我已审核</el-radio>
      </el-radio-group>
      <span style="margin-top: 4px; margin-left: 20px; display: inline-block">
        <el-button
          type="primary"
          icon="el-icon-search"
          size="small"
          @click="changeShow()"
          >搜索</el-button
        >
      </span>
    </div>
    <div class="mycontainer" style="margin-bottom: 10px" v-if="show">
      <el-form ref="queryForm" :model="listQuery" :inline="true">
        <!-- <el-form-item label="部门" prop="bmbh">
          <el-select
            ref="bmbh"
            v-model="listQuery.bmbh"
            placeholder="所属部门"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeTx"
          >
            <el-option
              v-for="item in bmList"
              :key="item.bmmc"
              :label="item.bmmc"
              :value="item.bmbh"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属条线" prop="txlx">
          <el-select
            ref="txlx"
            v-model="listQuery.txlx"
            placeholder="所属条线"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeLx"
          >
            <el-option
              v-for="item in ygtxoptions"
              :key="item.value"
              :label="item.value"
              :value="item.key"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="任务类型" prop="name">
          <el-select
            ref="name"
            v-model="listQuery.name"
            placeholder="任务类型"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
            @change="handleChangeZl"
          >
            <el-option
              v-for="item in lxList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item label="子类" prop="sun">
          <el-select
            ref="sun"
            v-model="listQuery.sun"
            placeholder="子类"
            clearable
            filterable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in zlList"
              :key="item.key"
              :label="item.value"
              :value="item.value"
            />
          </el-select>
        </el-form-item>-->

        <el-form-item label="认领人" prop="rlr">
          <treeselect
            v-model="listQuery.rlr"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 500px"
            size="small"
          />
        </el-form-item>

        <!-- <el-form-item label="任务标题" prop="title">
          <el-input
            v-model="listQuery.title"
            placeholder="请输入任务标题"
            clearable
            size="small"
            style="width: 200px"
          />
        </el-form-item>-->

        <span style="display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="medium"
            @click="getList()"
            >查询</el-button
          >

          <el-button
            type="primary"
            icon="el-icon-download"
            size="medium"
            @click="handleExport"
            style="margin-left: 15px"
            >导出</el-button
          >
        </span>
      </el-form>
    </div>
    <div class>
      <el-table
        :max-height="height"
        :data="list"
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        v-loading="listLoading"
        fit
        highlight-current-row
        empty-text="-"
        tooltip-effect="dark"
      >
        <el-table-column
          fixed
          label="操作"
          min-width="150"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button
              v-if="
                (scope.row.status === 2 ||
                  (scope.row.cgw_status === 1 && !scope.row.id)) &&
                scope.row.cgw_reviewer &&
                scope.row.cgw_reviewer !== ''
              "
              type="text"
              size="small"
              @click="
                handleReview(
                  scope.row.id,
                  scope.row.taskId,
                  scope.row.rlId,
                  scope.row.title,
                  scope.row.rwbh,
                  scope.row.txlxString,
                  scope.row.cgw_bz,
                  scope.row.bmmc
                )
              "
              >审核</el-button
            >

            <el-button
              v-if="
                scope.row.cgw_status === 1 &&
                scope.row.txlxString !== '技术' &&
                user.roleName.indexOf(scope.row.bmmc + '-部门管理员') !== -1
              "
              type="text"
              size="small"
              style="margin-left: 10px"
              @click="
                handleReviewer(
                  scope.row.taskId,
                  scope.row.rlId,
                  scope.row.title
                )
              "
              >调整审核人</el-button
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="status" label="审核状态" align="left" width="100">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.status === 1 ? 'success' :scope.row.status === 0 ? 'danger' : 'primary'"
              size="mini"
              disable-transitions
            >
              {{ scope.row.status === 2 ? "未审核" :
              scope.row.status === 3 ? "无需审核":
              scope.row.status === 1 ? "审核通过": scope.row.status === 0 ? "审核不通过" :"已终止"}}
            </el-tag>
          </template>
        </el-table-column>-->

        <el-table-column
          label="认领人"
          align="left"
          prop="rlr"
          min-width="100px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="审核人"
          prop="reviewerList"
          min-width="120px"
          align="center"
        >
          <template slot-scope="scope">
            <div class="border">
              <el-table
                style="width: 100%"
                :data="scope.row.reviewerList"
                :show-header="false"
                size="mini"
                empty-text="-"
              >
                <el-table-column
                  align="center"
                  prop="sh"
                  min-width="100px"
                  :show-overflow-tooltip="true"
                />
                <template slot="empty">
                  <div class="nodata">
                    <img src="@/img/nodata.png" alt="" width="160" />
                    <div>暂无数据</div>
                  </div>
                </template>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="审核状态"
          align="left"
          prop="ztmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        >
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.cgw_status === 3
                  ? 'success'
                  : scope.row.cgw_status === 0
                  ? 'danger'
                  : 'primary'
              "
              size="mini"
              disable-transitions
              >{{ scope.row.ztmc }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="审核时间"
          align="left"
          prop="shsj"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务编号"
          align="left"
          prop="rwbh"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务标题"
          align="left"
          prop="title"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务所属条线"
          align="left"
          prop="txlxString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务所属部门"
          align="left"
          prop="bmmc"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务类型"
          align="left"
          prop="name"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="子类"
          align="left"
          prop="sun"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="标准积分"
          align="left"
          prop="jf"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="协作人"
          align="left"
          prop="xzr"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="申请人"
          align="left"
          prop="sqr"
          min-width="80px"
          :show-overflow-tooltip="true"
        />

        <el-table-column
          label="任务开始时间"
          align="left"
          prop="qsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务结束时间"
          align="left"
          prop="jsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="txlx === '技术' ? '任务完成确认' : '成果物审核'"
      :visible.sync="cgwReviewDialog"
      width="90%"
      top="20px"
      :before-close="beforeClose"
      v-if="cgwReviewDialog"
    >
      <cgwReview
        v-if="cgwReviewDialog"
        ref="reviewDialog"
        :mxParams="mxParams"
        @hideDialog="closeCgwReviewDialog"
        @getList="getList"
      ></cgwReview>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="调整审核人"
      :visible.sync="cgwReviewerDialog"
      width="70%"
      top="20px"
      v-if="cgwReviewerDialog"
    >
      <cgwReviewer
        v-if="cgwReviewerDialog"
        ref="uploadForm"
        :mxParams="mxParams"
        @hideDialog="closeCgwReviewerDialog"
        @getList="getList"
      ></cgwReviewer>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Pagination from "@/components/Pagination";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import { getDictData } from "@/api/task.js";
import { getCgwReviewList, cgwListExport } from "@/api/cgw.js";
import {
  getBmxxList,
  getTasklxList,
  getTaskZlList,
  getKeyValue,
} from "@/api/taskType.js";
import cgwReviewer from "../cgw/cgwReviewer";
import cgwReview from "../cgw/cgwReview";
export default {
  // 列表分页
  components: {
    Pagination,
    cgwReview,
    cgwReviewer,
    Treeselect,
  },

  data() {
    return {
      radio: "2",
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      type: "0",
      height: 100,
      listQuery: {
        type: "",
        sun: "",
        name: "",
        bmbh: "",
        txlx: "",
        status: "2",
        rlr: null,
        title: "",
        page: 1,
        pageSize: 10,
      },
      listLoading: true,
      total: 0,
      value: "",
      time: [],
      list: [],
      ygtxoptions: [],
      bmList: [],
      lxList: [],
      zlList: [],
      statusList: [],
      rwzzForm: {
        id: "",
        zzly: "",
        rwbh: "",
        title: 0,
      },
      cgwReviewerDialog: false,
      cgwReviewDialog: false,
      show: false,
      txlx: "",
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "cgw"]),
  },
  created() {
    this.$store.dispatch("common/fetchUserInfoAction");

    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }

    getBmxxList("0").then((res) => {
      if (res.code == 0) {
        this.bmList = res.data;
      }
    });

    getTasklxList().then((res) => {
      if (res.code == 0) {
        this.lxList = res.data;
      }
    });
    getTaskZlList().then((res) => {
      if (res.code == 0) {
        this.zlList = res.data;
      }
    });

    getKeyValue("TXLX", "", "0").then((res) => {
      if (res.code === 0) {
        this.ygtxoptions = res.data;
      }
    });

    getDictData("rwxz_task_status", 1).then((res) => {
      if (res.code === 0) {
        this.statusList = res.data;
      }
    });
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClick(value) {
      this.listQuery.status = value;
      this.getList();
    },
    changeShow() {
      this.show = !this.show;
    },
    handleReview(id, taskId, rlId, rwmc, rwbh, txlx, bz, bmmc) {
      this.mxParams = {
        id,
        taskId,
        rlId,
        rwmc,
        rwbh,
        txlx,
        bz,
        admin: this.user.roleName.indexOf(bmmc + "-部门管理员"),
      };
      this.txlx = txlx;
      this.cgwReviewDialog = true;
    },

    beforeClose() {
      for (let index = 0; index < this.cgw.cgwList.length; index++) {
        const file = this.cgw.cgwList[index];
        this.$store.dispatch("cgw/fetchDeleteFileAction", {
          fileId: file.fileid,
          path: file.url,
        });
      }
      this.cgwReviewDialog = false;
    },

    closeCgwReviewDialog() {
      this.cgwReviewDialog = false;
    },

    handleReviewer(taskId, rlId, rwmc) {
      this.mxParams = {
        taskId,
        rlId,
        rwmc,
      };
      this.cgwReviewerDialog = true;
    },

    closeCgwReviewerDialog() {
      this.cgwReviewerDialog = false;
    },
    toTaskList() {
      this.$router.push({
        name: "taskList",
      });
    },
    getList() {
      let rlr = null;
      rlr = this.listQuery.rlr ? this.listQuery.rlr.join(",") : null;
      const params = { ...this.listQuery, rlr };
      getCgwReviewList(params).then((res) => {
        if (res.code == 0) {
          if (this.$route.params.taskId) {
            this.list = res.data.filter(
              (l) => l.taskId === this.$route.params.taskId
            );
            this.total = this.list.length;
          } else {
            this.list = res.data;
            this.total = res.count;
          }

          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          let mycontainerH = 0;
          if (this.show) {
            mycontainerH = document.querySelector(".mycontainer").clientHeight;
          }

          this.height = docH - 105 - mycontainerH;
        }
      });
    },
    handleChangeTx(i) {
      this.listQuery.bmbh = i;
      this.listQuery.bmmc = i;
      getKeyValue("TXLX", i, "1").then((res) => {
        if (res.code === 0) {
          this.ygtxoptions = res.data;
        }
      });
    },

    handleChangeLx() {
      getTasklxList(this.listQuery.bmbh, this.listQuery.txlx).then((res) => {
        if (res.code == 0) {
          this.lxList = res.data;
        }
      });
    },
    handleChangeZl() {
      getTaskZlList(
        this.listQuery.name,
        this.listQuery.bmbh,
        this.listQuery.txlx
      ).then((res) => {
        if (res.code == 0) {
          this.zlList = res.data;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },

    //导出
    handleExport() {
      let rlr = null;
      rlr = this.listQuery.rlr ? this.listQuery.rlr.join(",") : null;
      const params = { ...this.listQuery, rlr };
      cgwListExport(params).then((res) => {
        if (res.code === 0) {
          const fileName = res.msg.substr(
            res.msg.indexOf("_") + 1,
            res.msg.length
          );
          const filePath = res.msg;
          const url =
            window.g.apiUrl +
            "system/downloadFile?fileName=" +
            fileName +
            "&filePath=" +
            filePath;
          // 组装a标签
          const elink = document.createElement("a");
          // 设置下载文件名
          elink.download = fileName;
          elink.style.display = "none";
          elink.href = url;
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: "error",
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.vue-treeselect {
  line-height: 18px;
}
.myradio {
  margin-bottom: 5px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
  .dialog-footer {
    text-align: right;
    button {
      margin-left: 30px;
    }
  }
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}

.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}

#save-form .el-form-item {
  margin-bottom: 20px;
}
.row {
  margin-top: 15px;
  .title {
    height: 44px;
    background-color: #d7d7d7;
    padding-left: 15px;
    font-size: 16px;
    line-height: 44px;
    margin-bottom: 15px;
  }
  .step-wrap {
    padding: 0 10%;
  }
  .apply-info {
    display: flex;
    height: 44px;
    line-height: 44px;
    .item {
      padding: 0 50px;
    }
    div {
      display: flex;
    }
  }
}
.border /deep/ .el-table__row > td {
  /* 去除表格线 */
  border: none;
  padding: 0;
}
</style>
